const state = {
  visitedViews: []
};

const mutations = {
  SET_VIEW: (state, view) => {
    //直接设置tagview值
    state.visitedViews = [].concat(view);
  },
  ADD_VIEW: (state, route) => {
    //添加tagview
    let { fullPath, path, query, name, meta } = route;
    let view = { fullPath, path, query, name, meta };
    if (state.visitedViews.some(v => v.path == view.path)) return;
    let title = (view.query && view.query.title) || view.name;

    state.visitedViews.push(
      Object.assign({}, view, {
        title
      })
    );
    let count = Math.floor(((document.body.clientWidth || 1920) - 150) / 150);
    //计算最多放置多少个tagview 第一个150是左侧菜单栏宽度，第二个150是tagview宽度
    if (state.visitedViews.length > count) {
      //超过最多放置个数后，删除第一个
      state.visitedViews.shift();
    }
  },

  DEL_VIEW: (state, view) => {
    //删除tabview
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path == view.path) {
        state.visitedViews.splice(i, 1);
        break;
      }
    }
    sessionStorage.removeItem(`tab${view.path}`); //移除当前页面所缓存的tab名
  },

  UPDATE_VIEW: (state, route) => {
    //更新某个view
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path == route.path) {
        let { fullPath, path, query, name, meta } = route;
        let view = { fullPath, path, query, name, meta };
        let title = (view.query && view.query.title) || view.name;
        view.title = title;
        view.hasUpdate = route.hasUpdate; // 标记是否有未保存的数据
        state.visitedViews.splice(i, 1, view);
        break;
      }
    }
  }
};

const actions = {
  addView({ commit }, view) {
    //添加
    commit("ADD_VIEW", view);
  },
  delView({ commit, state }, view) {
    //删除
    return new Promise(resolve => {
      commit("DEL_VIEW", view);
      resolve({
        visitedViews: [...state.visitedViews]
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
